// extracted by mini-css-extract-plugin
export default {"root":"styles_root__yxw8m","link":"styles_link__r7ftC"};